import { IconRss } from '@tabler/icons-react'
import { InputHeading } from './InputHeading'
import { TextField } from './Fields'
import { Button } from './Button'

export const UploadRssInput = ({
  rssFeedUrl,
  setRssFeedUrl,
  errors,
  register,
}) => {
  const URL_PATTERN =
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$' // fragment locator

  return (
    <div className="w-full">
      <div className="flex w-full flex-col items-end">
        <div className="w-full">
          <TextField
            label={
              <InputHeading
                icon={<IconRss className="h-6 w-6 text-purple-500" />}
                title="RSS Feed URL"
                description="Enter the RSS Feed URL to fetch episodes from."
              />
            }
            id="rssFeedUrl"
            name="rssFeedUrl"
            placeholder="https://feeds.megaphone.fm/hubermanlab"
            value={rssFeedUrl}
            {...register('rssFeedUrl', {
              required: 'Please enter the RSS Feed URL.',
              pattern: {
                value: new RegExp(URL_PATTERN, 'i'),
                message: 'Please enter a valid URL.',
              },
            })}
            type="text"
            onChange={(e) => setRssFeedUrl(e.target.value)}
          />
        </div>
        {errors.rssFeedUrl && (
          <p className="mt-1 text-xs text-red-600">
            {errors.rssFeedUrl.message?.toString()}
          </p>
        )}
        <div>
          <Button icon={IconRss} className="mt-2">
            Fetch feed
          </Button>
        </div>
      </div>
    </div>
  )
}
